import {Box, IconButton, Paper, useTheme} from "@mui/material";
import {ArrowForwardIos, FirstPage} from "@mui/icons-material";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import React, {useContext} from "react";
import {DealsPageContext} from "../index";
import {userOptions} from "../../../user";

export const DealsPagination = () => {
  const theme = useTheme();
  const {loadNextDeals, loadPrevDeals, dealsNum, currentListOffset, loadDealsData} = useContext(DealsPageContext);
  const dealsOnPage = userOptions.dealsListLimit;

  return (
    <Box
      sx={{
        position: 'sticky',
        bottom: 0,
        zIndex: 10,
        width: '100%',
      }}
    >
      <Paper
        elevation={1}
        sx={{
          minHeight: '53px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          borderTopLeftRadius: 0,
          borderTopRightRadius: 0,
          borderTop: `0px solid ${theme.palette.divider}`,
          backgroundColor: theme.palette.background.paper,
          padding: '0 16px',
          flexShrink: 0,
        }}
      >
        <Box sx={{
          display: 'flex',
          alignItems: 'center',
          gap: '2px', // Минимальный отступ между стрелками
        }}>
          <IconButton
            style={{backgroundColor: 'transparent'}}
            disabled={!currentListOffset}
            onClick={() => {loadDealsData(0)}}
            sx={{
              p: '8px',
              color: theme.palette.icon.default,
            }}
            aria-label="directions">
            <FirstPage/>
          </IconButton>
          <IconButton
            style={{backgroundColor: 'transparent'}}
            onClick={loadPrevDeals}
            disabled={!currentListOffset}
            sx={{
              p: '8px',
              color: theme.palette.icon.default,
            }}
            aria-label="directions">
            <ArrowBackIosIcon sx={{fontSize: '12pt'}}/>
          </IconButton>
          <IconButton
            style={{backgroundColor: 'transparent'}}
            onClick={loadNextDeals}
            disabled={dealsNum < dealsOnPage}
            sx={{
              p: '8px',
              color: theme.palette.icon.default,
            }}
            aria-label="directions">
            <ArrowForwardIos sx={{fontSize: '12pt'}}/>
          </IconButton>
        </Box>
      </Paper>
    </Box>
  )
}